import React, { useEffect, useState } from 'react';
import PendingReceivables from "./components/receivable/PendingReceivables";
import Loading from "./core/Loading";
import { findPendingReceivablesByCustomerCompanyId } from "./utils/requestUtils";
import Cookies from "js-cookie";
import {normalizeDate, UserPermission} from "./utils/utils";
import {usePermission} from "./core/PermissionContext";

const MainPage = ({ children }) => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [pendingReceivables, setPendingReceivables] = useState(undefined);
    const [overdueReceivables, setOverdueReceivables] = useState(undefined);
    const [user, setUser] = useState(undefined);
    const today = normalizeDate(new Date());
    const sixDaysLater = new Date(today);
    sixDaysLater.setDate(today.getDate() + 6);

    // 🔥 Lê o user do cookie continuamente
    useEffect(() => {
        const interval = setInterval(() => {
            const userCookie = Cookies.get('user');
            setUser(prev => {
                if (prev !== userCookie) {
                    return userCookie;
                }
                return prev;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        if (user) {
            findPendingReceivablesByCustomerCompanyId()
                .then(pending => {
                    const upcomingReceivables = pending.filter((p) => {
                        const dueDate = p.dueDate ? normalizeDate(new Date(p.dueDate)) : null;
                        return p.status === 0 && dueDate && dueDate >= today && dueDate <= sixDaysLater;
                    });
                    setPendingReceivables(upcomingReceivables);

                    const overdue = pending.filter(receivable => {
                        const dueDate = receivable.dueDate ? normalizeDate(new Date(receivable.dueDate)) : null;
                        return receivable.status === 0 && dueDate && dueDate < today;
                    });

                    setOverdueReceivables(overdue);
                });
        }
    }, [user]);


    if (
        user === undefined ||
        pendingReceivables === undefined ||
        overdueReceivables === undefined ||
        loadingPermissions
    ) {
        return <Loading />;
    }

    const getBoxStyle = (type) => {
        const isSmallScreen = window.innerWidth < 400;
        if (type === 'overdue') {
            return {
                alignItems: 'center',
                display: 'inline-block',
                width: isSmallScreen ? '80%' : '365px',
                marginLeft: isSmallScreen ? '5px' : null,
                border: '2px solid #ffcccc',
                backgroundColor: '#fff5f5',
                padding: '12px',
                borderRadius: '10px',
                marginBottom: '20px'
            };
        }
        if (type === 'pending') {
            return {
                alignItems: 'center',
                display: 'inline-block',
                width: isSmallScreen ? '80%' : '365px',
                marginLeft: isSmallScreen ? '5px' : null,
                border: '2px solid #ffe680',
                backgroundColor: '#fffef0',
                padding: '12px',
                borderRadius: '10px',
                marginBottom: '20px'
            };
        }
        return {};
    };

    return (
        <div>
            {overdueReceivables.length > 0 && (
                <div style={getBoxStyle('overdue')}>
                    {hasUserPermission(UserPermission.ENABLE_PAY_COMPANY_RECEIVABLES) ?
                        <>
                            <h3 style={{color: '#cc0000'}}>
                                ⚠️ Você possui valores em atraso
                            </h3>
                            <PendingReceivables
                                overdueReceivables={overdueReceivables}
                                pendingReceivables={[]}
                            />
                        </>
                        :
                        <>
                            <h3 style={{color: '#cc0000'}}>
                                ⚠️ Entre em contato com o administrador do sistema.
                            </h3>
                        </>
                    }
                </div>
            )}

            {hasUserPermission(UserPermission.ENABLE_PAY_COMPANY_RECEIVABLES) && pendingReceivables.length > 0 && overdueReceivables.length === 0 && (
                <div style={getBoxStyle('pending')}>
                    <h3 style={{ color: '#b38f00' }}>
                        🔔 Você possui débitos para os próximos dias
                    </h3>
                    <PendingReceivables
                        overdueReceivables={[]}
                        pendingReceivables={pendingReceivables}
                    />
                </div>
            )}

            {overdueReceivables.length === 0 && children}

            {!children && overdueReceivables.length === 0 && pendingReceivables.length === 0 && (
                <>

                </>
            )}
        </div>
    );
};

export default MainPage;
